// extracted by mini-css-extract-plugin
export var fullGrid = "_2e-3";
export var pdpPreviewContainer = "_2e-1";
export var previewContainer = "_2e-0";
export var togglePreviewContainer = "_2e-2";